<cc-data-grid-features [stateConfig]="{ storageKey: storageKey, storeGroupings: true }" [dataSource]="taskGridSource">
    <dx-data-grid
        #taskGrid
        width="100%"
        height="100%"
        keyExpr="projectTaskId"
        [dataSource]="taskGridSource"
        (onContentReady)="onGridContentReady($event)"
        (onSelectionChanged)="onGridSelectionChanged($event)"
    >
        <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

        <dxi-column
            dataField="projectTaskId"
            dataType="number"
            caption="Task Id"
            cellTemplate="taskTemplate"
        ></dxi-column>
        <dxi-column dataField="status" dataType="string" caption="Status"></dxi-column>
        <dxi-column
            dataField="responsibleDisplayText"
            dataType="string"
            caption="Responsible"
            cellTemplate="responsibleTemplate"
        ></dxi-column>
        <dxi-column dataField="taskItem" dataType="string" caption="Task Item"></dxi-column>
        <dxi-column
            dataField="description"
            dataType="string"
            caption="Description"
            cellTemplate="descriptionTemplate"
        ></dxi-column>

        <div *dxTemplate="let r of 'responsibleTemplate'" class="responsible-container">
            <ng-container
                [ngTemplateOutlet]="singleUserTemplate"
                [ngTemplateOutletContext]="{ data: r.data, user: r.data.responsible }"
            ></ng-container>
        </div>

        <div *dxTemplate="let data of 'descriptionTemplate'">
            <div class="description-text" (click)="onDescriptionClick(data)">
                <a href="javascript:void(0)" class="cc-hyperlink">
                    {{ data.value }}
                </a>
            </div>
            <div
                *ngIf="data.rowIndex === longDescriptionGridIndex && showLongDescription"
                class="description-long-text"
            >
                {{ data.value }}
            </div>
        </div>

        <div *dxTemplate="let d of 'taskTemplate'">
            <div class="cell-link-content">
                <a href="javascript:void(0)" (click)="onTaskIdClick(d.data)">{{ d.value }}</a>
            </div>
        </div>
    </dx-data-grid>
</cc-data-grid-features>

<ng-template #singleUserTemplate let-user="user" let-data="data">
    <div class="res-content">
        <app-user-bio-link [user]="user" [communityId]="data.communityId"></app-user-bio-link>
    </div>
</ng-template>

<app-project-task-viewer
    *ngIf="showTaskViewer"
    [taskId]="selectedTask.projectTaskId"
    [communityId]="communityId"
    [notesActionCode]="PROJECTS_TASKS"
    (onClose)="onTaskViewerClose()"
></app-project-task-viewer>
